import { createWebApiDriverItem } from 'src_common/browser/apiUtils';

import { rabGetAvailability } from './config/eventsRab/rabGetAvailability';

import { getMobileUpdateVersion } from './config/mobileAppUpdateVersion/getAppUpdateVersion';
import { deleteMobileUpdateVersion } from './config/mobileAppUpdateVersion/deleteAppUpdateVersion';
import { postCreateMobileUpdateVersion } from './config/mobileAppUpdateVersion/postCreateAppUpdateVersion';
import { putCreateMobileUpdateVersion } from './config/mobileAppUpdateVersion/updateAppUpdateVersion';
import { deleteLandingPage } from './config/landingPage/deleteLandingPage';
import { getLandingPage } from './config/landingPage/getLandingPage';
import { postLandingPage } from './config/landingPage/postLandingPage';
import { putLandingPage } from './config/landingPage/putLandingPage';
import { deleteHeaderNavigationLink } from './config/headerNavigationLink/deleteHeaderNavigationLink';
import { getHeaderNavigationLink } from './config/headerNavigationLink/getHeaderNavigationLink';
import { postHeaderNavigationLink } from './config/headerNavigationLink/postHeaderNavigationLink';
import { putHeaderNavigationLink } from './config/headerNavigationLink/putHeaderNavigationLink';
import { getCMSFilesList } from './config/filesCMS/getCMSFilesList';
import { deleteCMSFile } from './config/filesCMS/deleteCMSFile';
import { withdrawalList } from './config/withdrawal/withdrawalList';
import { getHeaderNavigationLinks } from './config/headerNavigationLink/getHeaderNavigationLinks';
import { get_promo_notifications } from './config/promo_notifications/get_promo_notifications';
import { post_create_promo_notifications } from './config/promo_notifications/post_create_promo_notifications';
import { put_update_promo_notifications } from './config/promo_notifications/put_update_promo_notifications';
import { delete_promo_notifications } from './config/promo_notifications/delete_promo_notifications';
import { post_order_promo_notifications } from './config/promo_notifications/post_order_promo_notifications';

import { deletePage } from './config/page/deletePage';
import { getPageList } from './config/page/getPagesList';
import { putPage } from './config/page/putPage';
import { postPage } from './config/page/postPage';
import { get_hero_widget } from './config/hero_widget/get_hero_widget';
import { post_create_hero_widget } from './config/hero_widget/post_create_hero_widget';
import { put_update_hero_widget } from './config/hero_widget/put_update_hero_widget';
import { delete_hero_widget } from './config/hero_widget/delete_hero_widget';
import { post_order_hero_widget } from './config/hero_widget/post_order_hero_widget';

import { post_create_event_details } from './config/event_details/post_create_event_details';
import { get_event_details_list } from './config/event_details/get_event_details_list';
import { put_update_event_details } from './config/event_details/put_update_event_details';
import { delete_event_details } from './config/event_details/delete_event_details';

import { getWithdrawalHistory } from './config/automaticWithdrawal/getWithdrawalHistory';
import { postPutWithdrawalRule } from 'src/api/config/automaticWithdrawal/postPutWithdrawalRule';
import { getWithdrawalRules } from './config/automaticWithdrawal/getWithdrawalRules';
import { deleteWithdrawalRule } from './config/automaticWithdrawal/deleteWithdrawalRule';
import { postWithdrawalReview } from './config/automaticWithdrawal/postWithdrawalReview';
import { putAutomaticWithdrawal } from './config/automaticWithdrawal/putAutomaticWithdrawal';
import { getAutomaticWithdrawal } from './config/automaticWithdrawal/getAutomaticWithdrawal';

import { postCreateCustomSelectionsTemplate } from './config/customSelectionsTemplate/postCreateCustomSelectionsTemplate';
import { getCustomSelectionsTemplateList } from './config/customSelectionsTemplate/getCustomSelectionsTemplateList';
import { putUpdateCustomSelectionsTemplate } from './config/customSelectionsTemplate/putUpdateCustomSelectionsTemplate';
import { deleteCustomSelectionsTemplate } from './config/customSelectionsTemplate/deleteCustomSelectionsTemplate';

import { addNewMarketFilter } from './config/marketFilters/addnewMarketFilter';
import { getMarketFiltersForSport } from './config/marketFilters/getMarketFiltersForSport';
import { updateMarketFiltersForSport } from './config/marketFilters/updateMarketFiltersForSport';
import { getMarketsForSport } from './config/marketFilters/getMarketsForSport';
import { addMarketToFilter } from './config/marketFilters/addMarketToFilter';
import { updateMarketsForSport } from './config/marketFilters/updateMarketsForSport';
import { removeMarketFromFilter } from './config/marketFilters/removeMarketFromFilter';
import { removeMarketFilter } from './config/marketFilters/removeMarketFilter';
import { resetFilters } from './config/marketFilters/resetFilters';

import { getSpecialSports } from './config/special_sports/getSpecialSports';
import { postCreateSpecialSports } from './config/special_sports/postCreateSpecialSports';
import { putUpdateSpecialSports } from './config/special_sports/putUpdateSpecialSports';
import { deleteSpecialSports } from './config/special_sports/deleteSpecialSports';

import { updateCountry } from './config/admin/updateCountry';
import { getCountries } from './config/admin/getCountries';

import { getQuickLinkTray } from './config/quick_link_tray/getQuickLinkTray';
import { postCreateQuickLinkTray } from './config/quick_link_tray/postCreateQuickLinkTray';
import { putUpdateQuickLinkTray } from './config/quick_link_tray/putUpdateQuickLinkTray';
import { deleteQuickLinkTray } from './config/quick_link_tray/deleteQuickLinkTray';
import { postOrderQuickLinkTray } from './config/quick_link_tray/postOrderQuickLinkTray';
import { getAllTags } from './config/tags/getAll';

import { get_promo_codes } from './config/promo_codes/get_promo_codes';
import { post_create_promo_code } from './config/promo_codes/post_create_promo_code';
import { put_update_promo_code } from './config/promo_codes/put_update_promo_code';
import { delete_promo_code } from './config/promo_codes/delete_promo_code';

import { getCasinoMobileVersion } from './config/casinoMobileVersion/getCasinoMobileVersion';
import { postCreateCasinoMobileVersion } from './config/casinoMobileVersion/postCreateCasinoMobileVersion';
import { putUpdateCasinoMobileVersion } from './config/casinoMobileVersion/putUpdateCasinoMobileVersion';
import { deleteCasinoMobileVersion } from './config/casinoMobileVersion/deleteCasinoMobileVersion';
import { getCustomers } from './config/customers/getCustomers';

import { getHomePageCarousel } from './config/home_page_carousel/getHomePageCarousel';
import { postCreateHomePageCarousel } from './config/home_page_carousel/postCreateHomePageCarousel';
import { postOrderHomePageCarousel } from './config/home_page_carousel/postOrderHomePageCarousel';

import { getHeadlineCarousel } from './config/headlineCarousel/getHeadlineCarousel';
import { postCreateHeadlineCarousel } from './config/headlineCarousel/postCreateHeadlineCarousel';
import { putUpdateHeadlineCarousel } from './config/headlineCarousel/putUpdateHeadlineCarousel';
import { deleteHeadlineCarousel } from './config/headlineCarousel/deleteHeadlineCarousel';
import { postOrderHeadlineCarousel } from './config/headlineCarousel/postOrderHeadlineCarousel';

import { getAssetFlows } from './config/accounts/getAssetFlows';
import { get_welcome_bonuses } from './config/welcome_bonuses/get_welcome_bonuses';
import { delete_welcome_bonus } from './config/welcome_bonuses/delete_welcome_bonus';
import { put_update_welcome_bonus } from 'src/api/config/welcome_bonuses/put_welcome_bonus';

import { getIsonis, putIsonis } from './config/reports';
import { setDepositLimit } from 'src/api/config/depositLimits/accountSetDepositLimits';

import { getAllCmsTranslations } from './config/cmsTranslations/getAllCmsTranslations';
import { createCmsTranslation } from './config/cmsTranslations/createCmsTranslation';
import { updateCmsTranslation } from './config/cmsTranslations/updateCmsTranslation';
import { deleteCmsTranslation } from './config/cmsTranslations/deleteCmsTranslation';

import { getAllCmsDisplayOrders } from './config/cmsDisplayOrder/getAllDisplayOrders';

export const apiCommon = {
    rabGetAvailability: createWebApiDriverItem(rabGetAvailability),
    getLandingPage: createWebApiDriverItem(getLandingPage),
    postLandingPage: createWebApiDriverItem(postLandingPage),
    putLandingPage: createWebApiDriverItem(putLandingPage),
    deleteLandingPage: createWebApiDriverItem(deleteLandingPage),
    getHeaderNavigationLink: createWebApiDriverItem(getHeaderNavigationLink),
    getHeaderNavigationLinks: createWebApiDriverItem(getHeaderNavigationLinks),
    postHeaderNavigationLink: createWebApiDriverItem(postHeaderNavigationLink),
    putHeaderNavigationLink: createWebApiDriverItem(putHeaderNavigationLink),
    deleteHeaderNavigationLink: createWebApiDriverItem(deleteHeaderNavigationLink),
    getCMSFilesList: createWebApiDriverItem(getCMSFilesList),
    deleteCMSFile: createWebApiDriverItem(deleteCMSFile),
    withdrawalList: createWebApiDriverItem(withdrawalList),
    get_promo_notifications: createWebApiDriverItem(get_promo_notifications),
    post_create_promo_notifications: createWebApiDriverItem(post_create_promo_notifications),
    put_update_promo_notifications: createWebApiDriverItem(put_update_promo_notifications),
    delete_promo_notifications: createWebApiDriverItem(delete_promo_notifications),
    post_order_promo_notifications: createWebApiDriverItem(post_order_promo_notifications),
    getPagesList: createWebApiDriverItem(getPageList),
    postPage: createWebApiDriverItem(postPage),
    putPage: createWebApiDriverItem(putPage),
    deletePage: createWebApiDriverItem(deletePage),
    get_hero_widget: createWebApiDriverItem(get_hero_widget),
    post_create_hero_widget: createWebApiDriverItem(post_create_hero_widget),
    put_update_hero_widget: createWebApiDriverItem(put_update_hero_widget),
    delete_hero_widget: createWebApiDriverItem(delete_hero_widget),
    post_order_hero_widget: createWebApiDriverItem(post_order_hero_widget),
    post_create_event_details: createWebApiDriverItem(post_create_event_details),
    get_event_details_list: createWebApiDriverItem(get_event_details_list),
    put_update_event_details: createWebApiDriverItem(put_update_event_details),
    delete_event_details: createWebApiDriverItem(delete_event_details),
    autoWithdrawalHistory: createWebApiDriverItem(getWithdrawalHistory),
    postPutWithdrawalRule: createWebApiDriverItem(postPutWithdrawalRule),
    getWithdrawalRules: createWebApiDriverItem(getWithdrawalRules),
    deleteWithdrawalRule: createWebApiDriverItem(deleteWithdrawalRule),
    postWithdrawalReview: createWebApiDriverItem(postWithdrawalReview),
    putAutomaticWithdrawal: createWebApiDriverItem(putAutomaticWithdrawal),
    getAutomaticWithdrawal: createWebApiDriverItem(getAutomaticWithdrawal),
    postCreateCustomSelectionsTemplate: createWebApiDriverItem(postCreateCustomSelectionsTemplate),
    getCustomSelectionsTemplateList: createWebApiDriverItem(getCustomSelectionsTemplateList),
    putUpdateCustomSelectionsTemplate: createWebApiDriverItem(putUpdateCustomSelectionsTemplate),
    deleteCustomSelectionsTemplate: createWebApiDriverItem(deleteCustomSelectionsTemplate),
    marketFiltersAddNewFilter: createWebApiDriverItem(addNewMarketFilter),
    marketFiltersGetFilters: createWebApiDriverItem(getMarketFiltersForSport),
    marketFiltersUpdateFilters: createWebApiDriverItem(updateMarketFiltersForSport),
    marketFiltersGetMarketsForSport: createWebApiDriverItem(getMarketsForSport),
    marketFiltersAddMarketToFilter: createWebApiDriverItem(addMarketToFilter),
    marketFiltersUpdateMarketsForSport: createWebApiDriverItem(updateMarketsForSport),
    marketFiltersRemoveMarketFromFilter: createWebApiDriverItem(removeMarketFromFilter),
    marketFiltersRemoveFilter: createWebApiDriverItem(removeMarketFilter),
    marketFiltersResetFilters: createWebApiDriverItem(resetFilters),
    adminUpdateCountry: createWebApiDriverItem(updateCountry),
    adminGetCountries: createWebApiDriverItem(getCountries),
    getSpecialSports: createWebApiDriverItem(getSpecialSports),
    postCreateSpecialSports: createWebApiDriverItem(postCreateSpecialSports),
    putUpdateSpecialSports: createWebApiDriverItem(putUpdateSpecialSports),
    deleteSpecialSports: createWebApiDriverItem(deleteSpecialSports),
    getQuickLinkTray: createWebApiDriverItem(getQuickLinkTray),
    postCreateQuickLinkTray: createWebApiDriverItem(postCreateQuickLinkTray),
    putUpdateQuickLinkTray: createWebApiDriverItem(putUpdateQuickLinkTray),
    deleteQuickLinkTray: createWebApiDriverItem(deleteQuickLinkTray),
    postOrderQuickLinkTray: createWebApiDriverItem(postOrderQuickLinkTray),
    getAllTags: createWebApiDriverItem(getAllTags),
    get_promo_codes: createWebApiDriverItem(get_promo_codes),
    get_welcome_bonuses: createWebApiDriverItem(get_welcome_bonuses),
    put_welcome_bonus: createWebApiDriverItem(put_update_welcome_bonus),
    delete_welcome_bonus: createWebApiDriverItem(delete_welcome_bonus),
    post_create_promo_code: createWebApiDriverItem(post_create_promo_code),
    put_update_promo_code: createWebApiDriverItem(put_update_promo_code),
    delete_promo_code: createWebApiDriverItem(delete_promo_code),
    getCasinoMobileVersion: createWebApiDriverItem(getCasinoMobileVersion),
    postCreateCasinoMobileVersion: createWebApiDriverItem(postCreateCasinoMobileVersion),
    putUpdateCasinoMobileVersion: createWebApiDriverItem(putUpdateCasinoMobileVersion),
    deleteCasinoMobileVersion: createWebApiDriverItem(deleteCasinoMobileVersion),
    getCustomers: createWebApiDriverItem(getCustomers),

    getHomePageCarousel: createWebApiDriverItem(getHomePageCarousel),
    postCreateHomePageCarousel: createWebApiDriverItem(postCreateHomePageCarousel),
    postOrderHomePageCarousel: createWebApiDriverItem(postOrderHomePageCarousel),
    getAssetFlows: createWebApiDriverItem(getAssetFlows),

    // Mobile version update
    getMobileUpdateVersion: createWebApiDriverItem(getMobileUpdateVersion),
    deleteMobileUpdateVersion: createWebApiDriverItem(deleteMobileUpdateVersion),
    postCreateMobileUpdateVersion: createWebApiDriverItem(postCreateMobileUpdateVersion),
    updateMobileUpdateVersion: createWebApiDriverItem(putCreateMobileUpdateVersion),
    // doppler ISONIS Audit
    putIsonis: createWebApiDriverItem(putIsonis),
    getIsonis: createWebApiDriverItem(getIsonis),
    accountSetDepositLimit: createWebApiDriverItem(setDepositLimit),
    // Headline carousel
    getHeadlineCarousels: createWebApiDriverItem(getHeadlineCarousel),
    deleteHeadlineCarousel: createWebApiDriverItem(deleteHeadlineCarousel),
    postCreateHeadlineCarousel: createWebApiDriverItem(postCreateHeadlineCarousel),
    updateHeadlineCarousel: createWebApiDriverItem(putUpdateHeadlineCarousel),
    changeHeadlineCarouselOrder: createWebApiDriverItem(postOrderHeadlineCarousel),

    // Translations
    getAllCmsTranslations: createWebApiDriverItem(getAllCmsTranslations),
    createCmsTranslation: createWebApiDriverItem(createCmsTranslation),
    updateCmsTranslation: createWebApiDriverItem(updateCmsTranslation),
    deleteCmsTranslation: createWebApiDriverItem(deleteCmsTranslation),
    // Order change
    getAllCmsDisplayOrders: createWebApiDriverItem(getAllCmsDisplayOrders),
};

export type ApiCommonType = typeof apiCommon;
